import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import Layout from 'components/layout';
import Work from 'views/work';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../../meta/config';

class WorkPage extends Component {
  render() {
    const page = pages.work;
    const { navColors } = page;
    const canonical = `${config.siteUrl}/work/`;

    const { posts, contributors } = this.props.data;

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Work">
          <meta name={'description'} content={'...'} />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar
          color={navColors}
        />
        <PopupRedirect message={'work'} />
        <Work allArticles={posts.edges} contributors={contributors.edges} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query WorkPage {
    posts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          templateKey: { eq: "article-page" }
          settings: { category: { ne: "Case Study" } }
        }
      }
    ) {
      ...markdownFields
    }

    contributors: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          templateKey: { eq: "contributor-page" }
          settings: { category: { ne: "Case Study" } }
        }
      }
    ) {
      ...markdownFields
    }
  }
`;

export default WorkPage;
